import * as angular from 'angular';
import { Growl } from 'angular/custom/services/growl.service';
import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';
import { AuthService } from 'app/_services/auth.service';
import { ErrorHandler } from 'app/_services/error-handler.factory';

class UnderlyingDealSourcesSettingsComponentCtrl implements ng.IController {
    settings: TsoSecondarySettingsDto;
    private loggedInUser: LoginResult;
    private savingInProgress: boolean = false;
    private rememberSelectionPossibilityForManualUnderlyingDealSource: SelectionPossibility;

    constructor(
        private TransmissionSystemOperator: TransmissionSystemOperatorResource,
        private authService: AuthService,
        private growl: Growl,
        private errorHandler: ErrorHandler
    ) {}

    $onInit(): void {
        this.authService.userLoginPromise.promise.then(
            (res) => (this.loggedInUser = res)
        );
        this.rememberSelectionPossibilityForManualUnderlyingDealSource =
            this.settings.selectionPossibilityForManualUnderlyingDealSource;
    }

    changeSetting(underlyingDealSource: UnderlyingDealSource): void {
        this.savingInProgress = true;

        this.TransmissionSystemOperator.saveUnderlyingDealSourceConfig(
            {
                id: this.loggedInUser.referenceId,
                underlyingDealSource: underlyingDealSource
            },
            this.settings.underlyingDealSources[underlyingDealSource],
            () =>
                this.growl.show('Successfully saved.', 'success', {
                    delay: 2000
                }),
            (err: ng.IHttpPromiseCallbackArg<RestError>) => {
                this.errorHandler(err);
                this.settings.underlyingDealSources[underlyingDealSource] =
                    !this.settings.underlyingDealSources[underlyingDealSource];
            }
        ).$promise.finally(() => (this.savingInProgress = false));
    }

    changeSelectionPossibilityOfContractIdOnManualUnderlyingDeals(): void {
        this.savingInProgress = true;
        this.TransmissionSystemOperator.saveSelectionPossibilityOfContractIdOnManualUnderlyingDeals(
            { id: this.loggedInUser.referenceId },
            {
                selectionPossibility:
                    this.settings
                        .selectionPossibilityForManualUnderlyingDealSource
            },
            () =>
                this.growl.show('Successfully saved.', 'success', {
                    delay: 2000
                }),
            (err: ng.IHttpPromiseCallbackArg<RestError>) => {
                this.errorHandler(err);
                this.settings.selectionPossibilityForManualUnderlyingDealSource =
                    this.rememberSelectionPossibilityForManualUnderlyingDealSource;
            }
        ).$promise.finally(() => (this.savingInProgress = false));
    }
}

angular.module('app').component('pkpUnderlyingDealSourcesSettings', {
    controller: UnderlyingDealSourcesSettingsComponentCtrl,
    template:
        require('app/operator-settings-secondary-market/underlying-deal-sources-settings.component.html'),
    bindings: {
        settings: '='
    }
});
